
<template>
  <div class="press-item">
    <div class="inner">

      <div class="image" :style="{'background-image': `url('${model.image}')`}"></div>

      <div class="content">
        <div class="name">{{ model.name }}</div>

        <a :href="model.download" class="link-inverse" :download="model.download" target="_blank">
          Download
        </a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'press-item',
  props: {
    model: Object,
  },
};
</script>

<style lang="scss" scoped>
  .press-item {
    text-align: center;
    padding: 0 10px;
    margin-bottom: 20px;
    width: 33.3333%;

    @include media($mobile) {
      width: 50%;
    }

    @include media($smallMobile) {
      width: 100%;
    }
  }

  .inner {
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 14px 19px rgba(black, .08);
  }

  .image {
    height: 170px;
    background-color: white;
    background-position: center center;
    background-size: cover;
  }

  .content {
    padding: 20px;
  }

  .name {
    margin-bottom: 10px;
  }
</style>
